import React, { Fragment, useState } from "react";
import { Grid, Typography, Link } from "@mui/material";
import Project from "../../api/project";
import Header2 from "../../components/Header2/Header2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import SEO from "../../components/SEO";
import TexoraImg from "../../images/texora-AI.jpg";
import { ListOrdered } from "lucide-react";
import { Card } from "reactstrap";

const Texora = (props) => {
  const [activeFilter, setActiveFilter] = useState("all");

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  const filteredProjects =
    activeFilter === "all"
      ? Project.slice(9, 18)
      : Project.slice(9, 18).filter(
          (project) => project.category === activeFilter
        );

  return (
    <Fragment>
      <SEO
        title="Texora AI - Simplifying Hiring with Intelligence"
        description="Texora AI streamlines the hiring process with smart resume extraction, AI-powered matching, and effortless interview scheduling — making recruitment faster and smarter."
        url="https://www.ufsnetworks.com/texora"
        image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
        canonicalUrl="https://www.ufsnetworks.com/texora"
      />
      <Header2 />
      <main>
        <PageTitle
          pageTitle={"Revolutionizing Recruitment with AI-Powered Tools"}
          pagesub={"Texora AI"}
          pageTop={""}
        />
        <section className="container">
          <Grid container spacing={2} py={4}>
            <Grid item sm={5}>
                <img src={TexoraImg} alt="Texora AI" />
            </Grid>
            <Grid item sm={7}>
                <Typography variant="h2" fontSize={24} fontWeight={600} mb={.5}>
                    Texora AI: Simplifying Hiring with Intelligence 
                </Typography>
                <Typography> Texora AI is your AI recruitment co-pilot — transforming the way HR teams handle resumes, screen candidates, and run interviews. </Typography>
                <Typography my={1}>Texora.ai is an intelligent <b>HR Experience Platform</b> built to modernize employee journeys—from onboarding to engagement and beyond. Powered by AI, Texora bridges the gap between people, processes, skills, and performance, offering a seamless interface for HR technical leaders and employees alike.</Typography>
                <Typography fontWeight={600} my={1}>Here's what it does for you:</Typography>
                <ul style={{ listStyleType: 'numeric', paddingLeft: '32px', fontSize:'14px', lineHeight:'24px' }}>
                    <li><strong>Upload & Organize Resumes Easily</strong> Drag & drop or click to upload resumes. Organize them in folders based on roles — everything stored securely on the cloud.</li>
                    <li><strong>Smart Resume Extraction</strong> Texora extracts important info like skills, experience, and contact details. Find the perfect candidate using search and filters. </li>
                    <li><strong>Match Resumes with Job Descriptions</strong> Want to know who fits a job best? Upload the JD, and we'll show how closely each resume matches using advanced AI matching.</li>
                    <li><strong>Effortless Interview Scheduling</strong> Use pre-made email templates, auto-generate Zoom links, and schedule interviews in seconds. View all in a calendar. </li>
                    <li><strong>Interview Review Made Easy</strong> Upload your interview recording. Texora will transcribe it, summarize it, and even tell you how well the candidate performed.</li>
                </ul>
                <a className="p-2 px-4 rounded-md" style={{backgroundColor:'#0d6efd', color:'#fff'}} href="https://texora.ai/">Take a look</a>
            </Grid>
          </Grid>
        </section>
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default Texora;
